import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PatientComplainChip from "app/common/Component/PatientComplainChip";
import PopupForm from "app/common/Component/Popup/PopupForm";

import { renderOptionsCheckInCustomer } from "app/EgretLayout/SharedCompoents/SelectCustomer";
import ConsultantTableSection from "app/PatientManagement/CheckInList/Popup/ConsultantTableSection";
import {
  CHECK_LENGTH_PHONE_SEARCH,
  IS_CHECK_MANY_CHECKIN_ON_DAY,
  POSITION_CONSULTANT,
  POSITION_TELESALE,
  USE_DIRECT_COMPANION,
} from "app/appConfig";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import IconSearch from "app/common/Icon/IconSearch";
import IconUserEdit from "app/common/Icon/IconUserEdit";
import {
  GENDER_FEMALE_VALUE,
  LIST_GENDER,
  MARKETING_TYPE,
} from "app/common/LocalConst";
import {
  convertDataLead,
  getCurrentStaff,
  getSystemConfig,
  isAdmin,
  isRoleBranchManager,
  isRoleCheckinEditOnlySource,
  isRoleCheckinEditSource,
  isSalesConsultant,
} from "app/common/LocalFunction";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingStaff } from "app/services/StaffService";
import { pagingDepartment } from "app/services/StoreRequestService";
import { pagingVisitType } from "app/services/VisitTypeService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { filterCustomerOptions } from "utils";
import * as Yup from "yup";
import SearchPhoneAndSelectInput from "app/PatientManagement/CheckInList/Component/SearchPhoneAndSelectInput";
import { CompanionAutocomplete, CompanionInitializationEffect } from "app/PatientManagement/CheckInList/Component/CompanionAutocomplete";

const CheckInGeneralPopup = ({ handleAfterSubmit, formikRef }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const {
    handleChangeFormSearchDuplicate,
    handleChangeFormSearchOnlyLeadDuplicate,
    initDataCheckIn,
    saveOrUpdateCheckin,
    handleSearchDuplicateInPersonal,
    openCheckin,
    handleCloseCheckinPopup,
  } = useStore().patientManagementStore.checkInListStore;

  const department = useDefaultDepartment();
  const receptionist = getCurrentStaff();

  // const initialValues = useMemo(() => {
  //   return {
  //     department: !initDataCheckIn?.receptionEncId ? department : null,
  //     currentPatientSource: initDataCheckIn?.currentPatientSource || null,
  //     currentPatientSourceDetail:
  //       initDataCheckIn?.currentPatientSourceDetail || null,
  //     receptionist: !initDataCheckIn?.receptionEncId ? receptionist : null,
  //     ...initDataCheckIn,
  //     listConsultant: initDataCheckIn?.listConsultant || [],
  //   };
  // }, [initDataCheckIn, department, receptionist]);
  const validationSchemas = Yup.object({
    patient: Yup.object().shape({
      displayName: Yup.string()
        .trim()
        .required("Vui lòng nhập họ tên khách hàng")
        .min(2, "Họ tên quá ngắn")
        .max(100, "Họ tên quá dài"),

      phoneNumber: Yup.string()
        .trim()
        .required("Vui lòng nhập số điện thoại")
        .matches(/^\d{10,19}$/, "Số điện thoại không hợp lệ"),
    }),
    companionSearchPhone: Yup.string()
      .nullable()
      .when(["isCompanion", "leadId"], {
        is: (isCompanion, leadId) => !!isCompanion && !leadId,
        then: (schema) =>
          schema
            .trim()
            .required("Vui lòng nhập SĐT người đi cùng"),
        otherwise: (schema) => schema.notRequired(),
      }),
    department: Yup.object().nullable().required("Chưa chọn cơ sở!"),
    listConsultant: Yup.array()
      .test(
        "require-consultant-checkin",
        "Phải chọn ít nhất 1 nhân viên tư vấn",
        function (value) {
          const require =
            getSystemConfig("REQUIRE_CONSULTANT_CHECKIN") === true ||
            window.Configs?.REQUIRE_CONSULTANT_CHECKIN === true;

          if (!require) return true;

          return Array.isArray(value) && value.length > 0;
        },
      )
      .of(
        Yup.object().shape({
          staff: Yup.object()
            .nullable()
            .required("Vui lòng chọn nhân viên tư vấn"),
        }),
      ),
  });

  const handlePhoneNumberChange = async (phoneNumber, values) => {
    await handleChangeFormSearchDuplicate({
      phoneNumber,
      searchArchive: false,
      keyword: phoneNumber,
      // truyền tạm biến này qua search để khi chọn patient thì gán lại sau,
      dataValue: { ...values, checkTypeVisit: values?.visitType },
      hiddenClose: values?.hiddenClose,
    });
  };

  const handleCheckDuplicate = useCallback(async () => {
    let data = [];
    if (handleSearchDuplicateInPersonal) {
      data = await handleSearchDuplicateInPersonal({
        phoneNumber: initDataCheckIn?.patient?.phoneNumber,
        searchArchive: false,
        // truyền tạm biến này qua search để khi chọn patient thì gán lại sau,
        dataValue: {
          ...initDataCheckIn,
          checkTypeVisit: initDataCheckIn?.visitType,
        },
      });
    }
    return data;
  }, [
    handleSearchDuplicateInPersonal,
    initDataCheckIn,
  ]);
  useEffect(() => {
    if (
      initDataCheckIn?.patient?.phoneNumber &&
      initDataCheckIn?.visitId &&
      !initDataCheckIn?.leadId
    ) {
      handleCheckDuplicate();
    }
  }, [
    handleCheckDuplicate,
    initDataCheckIn?.leadId,
    initDataCheckIn?.patient?.phoneNumber,
    initDataCheckIn?.visitId,
  ]);
  let isAdminPermission = isAdmin();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  const editSource = isRoleCheckinEditOnlySource() && initDataCheckIn?.leadId;

  return (
    <PopupForm
        open={openCheckin}
        size="sm"
        handleClose={handleCloseCheckinPopup}
        title={"Check in"}
        formik={{
          initialValues: {
            department: !initDataCheckIn?.receptionEncId ? department : null,
            currentPatientSource: initDataCheckIn?.currentPatientSource || null,
            currentPatientSourceDetail:
              initDataCheckIn?.currentPatientSourceDetail || null,
            receptionist: !initDataCheckIn?.receptionEncId
              ? receptionist
              : null,
            ...initDataCheckIn,
            isCompanion: initDataCheckIn?.isCompanion || false,
            companionSearchPhone: initDataCheckIn?.companionSearchPhone || "",
            companion: initDataCheckIn?.companion || null,
            leadCompanion: initDataCheckIn?.leadCompanion || null,
            companionSourceId: initDataCheckIn?.companionSourceId || "",
            companionSharedSource: initDataCheckIn?.companionSharedSource || null,
            // Ưu tiên dữ liệu trả về từ API khi mở popup chỉnh sửa
            // Chỉ set mặc định khi tạo mới và chưa có listConsultant
            listConsultant:
              (Array.isArray(initDataCheckIn?.listConsultant) &&
                initDataCheckIn.listConsultant.length > 0)
                ? initDataCheckIn.listConsultant
                : isSalesConsultant() && receptionist
                  ? [{ staff: receptionist }]
                  : [],
          },
          //initialValues: initialValues, // use memo to create initialValues
          validationSchema: validationSchemas,
          enableReinitialize: true,
          onSubmit: async (values, { setSubmitting }) => {
            if (values.patient) {
              values.patient.displayName = values.patient.displayName?.trim();
              values.patient.phoneNumber = values.patient.phoneNumber?.trim();
            }

            let payloadCheckDuplicate = {
              phoneNumber: values?.patient?.phoneNumber,
              searchArchive: false,
              dataValue: { ...values, checkTypeVisit: values?.visitType },
              hiddenClose: true,
            };

            // Nếu không có cả leadId và patient.id: giữ nguyên logic tìm kiếm duplicate
            if (!values?.leadId && !values?.patient?.id) {
              const data = await handleChangeFormSearchDuplicate(
                payloadCheckDuplicate,
              );

              if (data?.length === 0) {
                // values.isMainPhoneNumber = true;
                await saveOrUpdateCheckin(values, { setSubmitting });
              }
            }
            // Nếu có patient.id nhưng không có leadId: chỉ tìm lead
            else if (!values?.leadId && values?.patient?.id) {
              const leadData = await handleChangeFormSearchOnlyLeadDuplicate(
                payloadCheckDuplicate,
              );

              // Nếu không tìm thấy lead thì tiếp tục submit
              if (leadData?.length === 0) {
                await saveOrUpdateCheckin(values, { setSubmitting });
              }
              // Nếu tìm thấy lead thì popup sẽ tự động mở, không submit
            }
            // Nếu có leadId: submit luôn
            else {
              await saveOrUpdateCheckin(values, { setSubmitting });
            }

            if (handleAfterSubmit) {
              handleAfterSubmit();
            }
          },
          innerRef: formikRef,
        }}
        action={({ submitForm, setFieldValue, isSubmitting, values }) => {
          return (
            <div className="flex-center gap-1">
              <CommonButton
                className="btn-primary"
                type="submit"
                disabled={isSubmitting}
              >
                {!isMobile && <IconUserEdit className="mr-2 " />}
                {values?.receptionEncId ? "Cập nhật" : "Check In"}
              </CommonButton>

              <CommonButton
                className="btn-gray"
                onClick={handleCloseCheckinPopup}
              >
                {!isMobile && <Block className="mr-2" />}
                Đóng
              </CommonButton>
            </div>
          );
        }}
      >
        {({ setFieldValue, values, setSubmitting, submitForm }) => {
          return (
            <>
              <Grid container spacing={1} className="w-100 m-0">
                <Grid item xs={12} sm={12} className="flex gap-2 align-end">
                  {!values?.visitId ? (
                    <SearchPhoneAndSelectInput
                      name={"patient.phoneNumber"}
                      label="Số điện thoại"
                      autoUpercase
                      required
                      checkLength={CHECK_LENGTH_PHONE_SEARCH}
                      isSearchFreeSolo
                      // className="select-customer"
                      onChange={(_, patient) => {
                        // check là lead hay patient
                        if (patient?.saleType) {
                          let convertPatient = convertDataLead(patient);
                          setFieldValue("patient", {
                            ...convertPatient,
                            phoneNumber: patient?.phoneNumber,
                            // để UI/logic dùng chung có thể đọc được nguồn + telesale
                            currentPatientSource: patient?.leadSource || null,
                            currentTelesale: patient?.agent || null,
                          });
                          setFieldValue("leadId", patient?.id);
                          setFieldValue("lead", patient);
                          setFieldValue(
                            "marketingType",
                            patient?.marketingType,
                          );
                          // setFieldValue("isMainPhoneNumber", true);
                          setFieldValue("phoneNumber", patient?.phoneNumber);
                        } else {
                          setFieldValue("patient", {
                            ...patient,
                            phoneNumber: patient?.phoneNumber,
                            displayName:
                              patient?.fullName || patient?.displayName || "",
                            gender: patient?.gender
                              ? patient?.gender
                              : GENDER_FEMALE_VALUE,
                          });

                          setFieldValue("phoneNumber", patient?.phoneNumber);
                          setFieldValue("marketingType", null);
                        }
                      }}
                      disableClearable
                      ListboxComponent={forwardRef((props, ref) => {
                        const { children, ...other } = props;
                        return (
                          <ul {...other} ref={ref}>
                            <ol
                              className={"custom-listbox-customer box-checkin"}
                            >
                              <li>{children}</li>
                            </ol>
                          </ul>
                        );
                      })}
                      renderOption={(option) =>
                        renderOptionsCheckInCustomer(option)
                      }
                      filterOptions={filterCustomerOptions}
                      handleOnInput={(text) => {
                        if (values?.leadId) {
                          setFieldValue("leadId", null);
                          setFieldValue("lead", null);
                          setFieldValue("patient.id", null);
                          setFieldValue("patient.code", null);
                          setFieldValue("patient.leadCode", null);
                        } else if (values?.patient?.id) {
                          setFieldValue("patient.id", null);
                          setFieldValue("patient.code", null);
                        }
                      }}
                    />
                  ) : (
                    <GlobitsTextField
                      name={"patient.phoneNumber"}
                      label="Số điện thoại"
                      autoUpercase
                      required
                      onChange={(e) => {
                        const value = e.target.value;
                        setFieldValue("patient.phoneNumber", value);
                        if (!(values?.id || values?.patient?.id)) {
                          if (
                            value &&
                            value.length >= CHECK_LENGTH_PHONE_SEARCH
                          ) {
                            handlePhoneNumberChange(value, {
                              ...values,
                              hiddenClose: true,
                            });
                          }
                        }
                      }}
                    />
                  )}

                  {!values?.visitId && (
                    <CheckDuplicatePhoneButton
                      handleCheckDuplicatePhone={() => {
                        const value = getIn(values, "patient.phoneNumber");
                        if (
                          value &&
                          value.length >= CHECK_LENGTH_PHONE_SEARCH
                        ) {
                          handlePhoneNumberChange(value, values);
                        }
                      }}
                    />
                  )}
                </Grid>

                <Grid item xs={12} sm={12} className="flex gap-2 align-end flex-wrap">
                  {!values?.visitId &&
                    !values?.leadId &&
                    values?.patient?.id && (
                      <span className="flex align-center flex-wrap gap-1">
                        {`Đã chọn KH (${values?.patient?.code} ${
                          values?.patient?.displayName ||
                          values?.patient?.fullName
                        })`}
                        <PatientComplainChip
                          complainStatus={values?.patient?.complainStatus}
                        />
                      </span>
                    )}
                  {!values?.visitId &&
                    values?.leadId &&
                    `Đã chọn Lead (${values?.patient?.leadCode} ${
                      values?.patient?.displayName
                    })
                    ${
                      values?.lead?.leadSource
                        ? ` - Nguồn: ${values?.lead?.leadSource?.name}`
                        : ""
                    }
                     ${
                       values?.lead?.agent
                         ? ` - Telesale: ${
                             values?.lead?.agent?.staffName ||
                             values?.lead?.agent?.name ||
                             ""
                           }`
                         : ""
                     }
                    
                    `}
                </Grid>

                {/* <Grid item xs={12} sm={12}>
                  <GlobitsCheckBox
                    label="Người dùng chính của SĐT"
                    name="isMainPhoneNumber"
                  />
                </Grid> */}
                <Grid item xs={12} sm={12} className="flex gap-2 align-end flex-wrap">
                  <div className="flex-1" style={{ minWidth: 200 }}>
                    <GlobitsTextField
                      name={"patient.displayName"}
                      label={`Họ tên ${values?.leadId ? "lead" : "khách hàng"}`}
                      autoUpercase
                      required
                    />
                  </div>
                  <PatientComplainChip
                    complainStatus={values?.patient?.complainStatus}
                    className="mb-2"
                  />
                </Grid>

                <CompanionInitializationEffect />
                <CompanionAvailabilityEffect />
                <Grid item xs={12} sm={12}>
                  <div className="companion-box">
                    <div className="companion-box__title">Người đi cùng / đi kèm</div>
                    <Grid container spacing={1}>
                      {USE_DIRECT_COMPANION ? (
                        <Grid item xs={12} sm={6}>
                          <GlobitsCheckBox
                            label="Có người đi cùng"
                            name="isCompanion"
                            disabled={
                              !(values?.patient?.phoneNumber || "")
                                .trim()
                                .length >= (CHECK_LENGTH_PHONE_SEARCH || 0) ||
                              !!values?.leadId ||
                              !!values?.lead
                            }
                            onChange={({ target }) => {
                              const checked = !!target?.checked;
                              if (!checked) {
                                setFieldValue("isCompanion", false);
                                setFieldValue("leadCompanion", null);
                                setFieldValue("companion", null);
                                setFieldValue("companionSourceId", "");
                                setFieldValue("companionSearchPhone", "");
                                setFieldValue("companionSharedSource", null);
                                return;
                              }
                              const mainPhone =
                                values?.patient?.phoneNumber?.trim?.() || "";
                              const hasMainPhone =
                                mainPhone.length >= (CHECK_LENGTH_PHONE_SEARCH || 0);
                              if (!hasMainPhone) return;
                              if (values?.leadId || values?.lead) return;
                              setFieldValue("isCompanion", true);
                            }}
                            style={{
                              fontSize: "14px",
                              height: "100%",
                            }}
                          />
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={6}>
                          <GlobitsCheckBox
                            label="Có người đi kèm"
                            name="isCompanions"
                            disabled={!!values?.leadId || !!values?.lead}
                            style={{
                              fontSize: "14px",
                              height: "100%",
                            }}
                          />
                        </Grid>
                      )}

                      {values?.isCompanion && !values?.leadId && (
                        <Grid item xs={12}>
                          <CompanionAutocomplete />
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GlobitsDateTimePicker
                    name={"patient.birthDate"}
                    label={`Ngày sinh ${
                      values?.leadId ? "lead" : "khách hàng"
                    }`}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <GlobitsSelectInput
                    label={t("gender")}
                    name={"patient.gender"}
                    options={LIST_GENDER}
                    autoUpercase
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <GlobitsDateTimePicker
                    label="Thời gian check in"
                    name="issueDate"
                    isDateTimePicker
                    // disabled
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GlobitsPagingAutocomplete
                    name={"department"}
                    label={t("Cơ sở check in")}
                    api={pagingDepartment}
                    autoUpercase
                    disabled
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GlobitsPagingAutocomplete
                    name={"receptionist"}
                    label={t("Người check in")}
                    api={pagingStaff}
                    autoUpercase
                    displayLabel="staffName"
                    searchObject={{
                      departmentId: values?.department?.id,
                      positionCodes: [POSITION_CONSULTANT],
                      isActive: true,
                    }}
                    disabled={
                      !isAdminPermission && !isRoleBranchManagerPermission
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <GlobitsPagingAutocomplete
                    name={"visitType"}
                    label={"Loại check in"}
                    api={pagingVisitType}
                  />
                </Grid>

                {values?.leadId && (
                  <Grid item xs={12} sm={12}>
                    <GlobitsSelectInput
                      label={t("Loại khách")}
                      name={"marketingType"}
                      options={MARKETING_TYPE}
                      disabled={!isAdminPermission}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={12}>
                  <ConsultantTableSection />
                </Grid>

                {!!values?.visitId && (
                  <>
                    <Grid item xs={12} sm={12}>
                      <GlobitsPagingAutocomplete
                        name={"currentPatientSource"}
                        label={t("Nguồn")}
                        api={pagingCustomerSource}
                        searchObject={{
                          level: 2,
                        }}
                        disabled={
                          !(
                            isAdmin() ||
                            isRoleCheckinEditSource() ||
                            editSource
                          )
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <GlobitsPagingAutocomplete
                        name={"currentPatientSourceDetail"}
                        label={t("Nguồn chi tiết")}
                        api={pagingCustomerSource}
                        autoUpercase
                        searchObject={{
                          parentId:
                            getIn(values, "currentPatientSource")?.id || "",
                        }}
                        disabled={
                          !(
                            isAdmin() ||
                            isRoleCheckinEditSource() ||
                            editSource
                          )
                        }
                      />
                    </Grid>
                  </>
                )}
                {!!values?.visitId && (
                  <Grid item xs={12} sm={12}>
                    <GlobitsPagingAutocomplete
                      name={"currentTelesale"}
                      label={t("Telesale hiện thời")}
                      api={pagingStaff}
                      getOptionLabel={(option) => option?.staffName || ""}
                      searchObject={{
                        positionCode: POSITION_TELESALE,
                        isActive: true,
                      }}
                      disabled={!(isAdmin() || isRoleCheckinEditSource())}
                    />
                  </Grid>
                )}


                {/* <Grid item xs={12} sm={6}>
                  <GlobitsCheckBox
                    label="Không có KH/lead trùng"
                    name="isUnlistedPatient"
                    disabled
                  />
                </Grid> */}
              </Grid>

              <DialogCheckIn
                handleSubmit={async (newValues, { setSubmitting }) => {
                  await saveOrUpdateCheckin(newValues, { setSubmitting });
                }}
                handleClose={handleCloseCheckinPopup}
                isPatientGeneral={true}
              />
              <DialogHasAppointment
                handleSubmit={async (newValues, { setSubmitting }) => {
                  await saveOrUpdateCheckin(newValues, { setSubmitting });
                }}
              />
              <DialogError />
            </>
          );
        }}
      </PopupForm>
  );
};

const DialogCheckIn = observer(
  ({ handleSubmit, handleClose, isPatientGeneral }) => {
    const { values, setSubmitting } = useFormikContext();
    const { openConfirmCheckIns, setOpenConfirmCheckIns } =
      useStore().patientManagementStore.checkInListStore;
    return (
      <>
        {openConfirmCheckIns && (
          <GlobitsConfirmationDialog
            title="Tiếp tục check in!"
            text={openConfirmCheckIns}
            onConfirmDialogClose={() => {
              setOpenConfirmCheckIns(null);
            }}
            onYesClick={async () => {
              await handleSubmit(
                { ...values, skipCheckValiate: true },
                { setSubmitting },
              );
              setOpenConfirmCheckIns(null);
            }}
            cancel="Hủy"
            {...(IS_CHECK_MANY_CHECKIN_ON_DAY ? { agree: "Tiếp tục" } : {})}
            open={!!openConfirmCheckIns}
          />
        )}
      </>
    );
  },
);

const DialogHasAppointment = observer(({ handleSubmit }) => {
  const { values, setSubmitting } = useFormikContext();
  const { openConfirmHasAppointment, setOpenConfirmHasAppointments } =
    useStore().patientManagementStore.checkInListStore;
  return (
    <>
      {!!openConfirmHasAppointment && (
        <GlobitsConfirmationDialog
          maxWidth={"xs"}
          title="Tiếp tục check in!"
          text={openConfirmHasAppointment?.responseDetail}
          onConfirmDialogClose={() => {
            setOpenConfirmHasAppointments(null);
          }}
          onYesClick={async () => {
            await handleSubmit(
              {
                ...values,
                appointmentId: openConfirmHasAppointment?.appointmentId,
                skipCheckValiate: true,
              },
              { setSubmitting },
            );
            setOpenConfirmHasAppointments(null);
          }}
          cancel="Hủy"
          agree="Cập nhật lịch"
          open={!!openConfirmHasAppointment}
        />
      )}
    </>
  );
});

const DialogError = observer(() => {
  const { openConfirmError, setOpenConfirmError } =
    useStore().patientManagementStore.checkInListStore;
  return (
    <>
      {!!openConfirmError && (
        <GlobitsConfirmationDialog
          maxWidth={"xs"}
          title="Thông báo!"
          text={openConfirmError?.responseDetail}
          onConfirmDialogClose={() => {
            setOpenConfirmError(null);
          }}
          cancel="Đóng"
          open={!!openConfirmError}
        />
      )}
    </>
  );
});

const CheckDuplicatePhoneButton = observer(({ handleCheckDuplicatePhone }) => {
  return (
    <>
      <div className="flex align-end">
        <Tooltip title="Kiểm tra trùng số điện thoại">
          <CommonButton
            className="btn-primary"
            // style={{ display: "flex", height: "26.5px" }}
            onClick={handleCheckDuplicatePhone}
          >
            <IconSearch />
          </CommonButton>
        </Tooltip>
      </div>
    </>
  );
});



export default memo(observer(CheckInGeneralPopup));

const CompanionAvailabilityEffect = observer(() => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    const mainPhone = values?.patient?.phoneNumber?.trim?.() || "";
    const hasMainPhone = mainPhone.length >= (CHECK_LENGTH_PHONE_SEARCH || 0);
    const isLeadMain = !!values?.leadId || !!values?.lead;
    const canUseCompanion = hasMainPhone && !isLeadMain;

    if (!canUseCompanion && values?.isCompanion) {
      setFieldValue("isCompanion", false);
      setFieldValue("leadCompanion", null);
      setFieldValue("companion", null);
      setFieldValue("companionSourceId", "");
      setFieldValue("companionSearchPhone", "");
      setFieldValue("companionSharedSource", null);
    }
  }, [
    values?.patient?.phoneNumber,
    values?.leadId,
    values?.lead,
    values?.isCompanion,
    setFieldValue,
  ]);

  return null;
});
